<template>
  
  <search-picker 
    ref="searchPicker"
    path="owners" 
    attributes="id,name,email"
    :authToken="authToken"
    :fluid="fluid"
    :renderTitle="renderTitle"
    :renderDescription="renderDescription"
    @onClear="$emit('onClear')" 
    @onPick="onPick" 
  />

</template>

<script>

  import SearchPicker from "./search-picker"

  export default {

    name: "OwnerPicker",

    props: {
      authToken: { type: String },
      fluid: { type: Boolean, default: true },      
    },
    
    components: {
      SearchPicker,
    },  

    methods: {

      renderTitle(owner) {
        return owner.name
      },

      renderDescription(owner) {

        if (!owner.email)
          return ""

        return `<div class="m-t-10"><i class="envelope outline blue icon"></i> ${owner.email}</div>`
      },

      clear() {
        this.$refs.searchPicker.clear()
      },      

      onPick(owner) {
        this.$emit("onPick", owner)
      },

      setSelected(owner) {
        this.$refs.searchPicker.setSelected(owner)
      },
    },
  }

</script>